import React from 'react';

import Accordion from './Accordion';
import Benefits from './Benefits';
import BenefitsAccordion from './BenefitsAccordion';
import BenefitsContent from './BenefitsContent';
import BenefitsList from './BenefitsList';
import BlogArticles from './BlogArticles';
import BlogCtaCard from './BlogCtaCard';
import CalloutText from './CalloutText';
import CardGrid from './CardGrid';
import CaseStudies from './CaseStudies';
import CompanyList from './CompanyList';
import CtaCard from './CtaCard';
import DividerContentBlock from './DividerContentBlock';
import FactoringInfoGraphic from './FactoringInfoGraphic';
import FinancingCta from './FinancingCta';
import FormContentBlock from './FormContentBlock';
import FuelSavingsCalculator from './FuelSavingsCalculator';
import GravityForms from './GravityForms';
import HeroBanner from './HeroBanner';
import HeroBannerWithForm from './HeroBannerWithForm';
import Highlight from './Highlight';
import LogoRows from './LogoRows';
import LogoScroll from './LogoScroll';
import MainHero from './MainHero';
import NewsAndInsightsContentBlock from './NewsAndInsightsContentBlock';
import NewsletterSignup from './NewsletterSignup';
import OurHistory from './OurHistory';
import Partners from './Partners';
import Solutions from './Solutions';
import SolutionsCards from './SolutionsCards';
import TeamMembers from './TeamMembers';
import Testimonials from './Testimonials';
import TextContent from './TextContent';
import TextHeader from './TextHeader';
import Thrive from './Thrive';
import TwoColumnCta from './TwoColumnCta';
import TwoColumnPromo from './TwoColumnPromo';
import { AcfFragment } from './types';
import VideoContentBlock from './VideoContentBlock';

export const mapAcfBlockToContentBlock = (pageType: 'page' | 'post', pageId: string) =>
  function(acfFragment: AcfFragment, index: number): null | React.JSX.Element {
    switch (acfFragment.__typename) {
      case 'AcfAccordion': {
        return (
          <Accordion
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfBenefits': {
        return (
          <Benefits
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfBenefitsaccordion': {
        return (
          <BenefitsAccordion
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfBenefitscontent': {
        return (
          <BenefitsContent
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfBenefitslist': {
        return (
          <BenefitsList
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfBlogarticles': {
        return (
          <BlogArticles
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfBlogctacard': {
        return (
          <BlogCtaCard
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
            pageType={pageType}
          />
        );
      }
      case 'AcfCallouttext': {
        return (
          <CalloutText
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfCardgrid': {
        return (
          <CardGrid
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfCasestudies': {
        return (
          <CaseStudies
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfCompanylist': {
        return (
          <CompanyList
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfCtacard': {
        return (
          <CtaCard
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfDivider': {
        return (
          <DividerContentBlock
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfFactoringinfographic': {
        return (
          <FactoringInfoGraphic
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfFinancingcta': {
        return (
          <FinancingCta
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfForm': {
        return (
          <FormContentBlock
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfFuelsavingscalculator': {
        return (
          <FuelSavingsCalculator
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfHerobanner': {
        return (
          <HeroBanner
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfHerobannerwithform': {
        return (
          <HeroBannerWithForm
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfHighlight': {
        return (
          <Highlight
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfLogorows': {
        return (
          <LogoRows
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfLogoscroll': {
        return (
          <LogoScroll
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfMainhero': {
        return (
          <MainHero
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfNewsandinsights': {
        return (
          <NewsAndInsightsContentBlock
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfNewslettersignup': {
        return (
          <NewsletterSignup
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfOurhistory': {
        return (
          <OurHistory
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfPartners': {
        return (
          <Partners
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfSolutions': {
        return (
          <Solutions
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfSolutionscards': {
        return (
          <SolutionsCards
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfTeammembers': {
        return (
          <TeamMembers
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfTestimonials': {
        return (
          <Testimonials
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfTextcontent': {
        return (
          <TextContent
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfTextheader': {
        return (
          <TextHeader
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfThrive': {
        return (
          <Thrive
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfTwocolumncta': {
        return (
          <TwoColumnCta
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfTwocolumnpromo': {
        return (
          <TwoColumnPromo
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case 'AcfVideo': {
        return (
          <VideoContentBlock
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
            pageType={pageType}
          />
        );
      }
      case 'GravityformsForm': {
        return (
          <GravityForms
            fragment={acfFragment}
            key={`${pageId}-${index.toString()}-${acfFragment.__typename}`}
          />
        );
      }
      case undefined:
      default:
        return null;
    }
  };
